<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="saldoCuti && saldoCuti.id ? `Tambah Saldo Cuti Cuti`:`Ubah Saldo Cuti Cuti`"
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row wrap>
              <v-col cols="12" sm="12" md="12" lg="12">
                <span class="primary--text font-weight-bold">Nama Saldo Cuti</span>
                <v-text-field
                  class="mr-5"
                  type="string"
                  label="Nama"
                  v-model="saldoCuti.nama"
                  hint="Nama"
                  data-vv-name="nama"
                  data-vv-as="Label"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.nama')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6">
                <span class="primary--text font-weight-bold">Memerlukan Masa Kerja Tertentu</span>
                <v-radio-group
                  v-model="saldoCuti.is_masa_kerja"
                  row
                  data-vv-name="is_masa_kerja"
                  data-vv-as="Masa Kerja"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.is_masa_kerja')"
                >
                  <v-radio label="Ya" :value="true"></v-radio>
                  <v-radio label="Tidak" :value="false"></v-radio>
                </v-radio-group>
                <span
                  class="caption black--text"
                >Jika dipilih YA, maka wajib menambahkan berapa masa kerja yang harus dipenuhi untuk mendapatkan cuti (dalam bulan)</span>
                <v-text-field
                  v-if="saldoCuti.is_masa_kerja==true"
                  class="mr-5"
                  type="string"
                  label="Masa Kerja"
                  v-model="saldoCuti.masa_kerja"
                  hint="Jumlah Masa Kerja yang harus dipenuhi (Bulan)"
                  persistent-hint
                  data-vv-name="masa Kerja"
                  data-vv-as="Masa Kerja"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.masa_kerja')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <span class="primary--text font-weight-bold">Memerlukan Persetujuan Atasan</span>
                <v-radio-group
                  v-model="saldoCuti.is_approval"
                  row
                  data-vv-name="is_approval"
                  data-vv-as="Persetujuan"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.is_approval')"
                >
                  <v-radio label="Ya" :value="true"></v-radio>
                  <v-radio label="Tidak" :value="false"></v-radio>
                </v-radio-group>
                <span
                  class="caption black--text"
                >Jika dipilih YA, maka Setiap ajuan cuti memerlukan persetujuan atasan</span>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <span class="primary--text font-weight-bold">Menerapkan Saldo Cuti</span>
                <v-radio-group
                  v-model="saldoCuti.is_saldo"
                  row
                  data-vv-name="is_saldo"
                  data-vv-as="Saldo Cuti"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.is_saldo')"
                >
                  <v-radio label="Ya" :value="true"></v-radio>
                  <v-radio label="Tidak" :value="false"></v-radio>
                </v-radio-group>
                <span
                  class="caption black--text"
                >Jika dipilih YA, maka wajib menambahkan jumlah maksimal cuti (hari)</span>
                <v-text-field
                  v-if="saldoCuti.is_saldo==true"
                  class="mr-5"
                  type="string"
                  label="Jumlah maksimal cuti"
                  v-model="saldoCuti.jumlah"
                  hint="Jumlah Maksimal Cuti Per tahun"
                  data-vv-name="jumlah"
                  data-vv-as="Jumlah Maksimal Cuti"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.jumlah')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <span
                  class="primary--text font-weight-bold"
                >Mewajibkan mengunggah Lampiran/Berkas Pendukung</span>
                <v-radio-group
                  v-model="saldoCuti.is_lampiran"
                  row
                  data-vv-name="is_lampiran"
                  data-vv-as="Lampiran"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.is_lampiran')"
                >
                  <v-radio label="Ya" :value="true"></v-radio>
                  <v-radio label="Tidak" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="6" lg="6">
                <span class="primary--text font-weight-bold">Sisa Cuti Diakumulasikan ke Tahun berikutnya</span>
                <v-radio-group v-model="saldoCuti.is_akumulasi" row>
                  <v-radio label="Ya" :value="true"></v-radio>
                  <v-radio label="Tidak" :value="false"></v-radio>
                </v-radio-group>
                <span
                  class="caption black--text"
                >Jika dipilih YA, maka masukkan maksimal sisa cuti yang bisa diambil</span>
                <v-text-field
                  v-if="saldoCuti.is_akumulasi==true"
                  class="mr-5"
                  type="string"
                  label="Jumlah maksimal sisa cuti"
                  v-model="saldoCuti.sisa_cuti"
                  hint="Jumlah Maksimal Sisa cuti yang bisa diambil diperiode selanjutnya"
                  data-vv-name="sisa_cuti"
                  data-vv-as="Label"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.sisa_cuti')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <span class="primary--text font-weight-bold">Keterkaitan Cuti dalam tahun berjalan</span>
                <v-radio-group v-model="saldoCuti.is_related" row>
                  <v-radio label="Ya" :value="true"></v-radio>
                  <v-radio label="Tidak" :value="false"></v-radio>
                </v-radio-group>
                <span
                  class="caption black--text"
                >Jika dipilih YA, maka Saldo Cuti Cuti ini mengurangi jatah cuti tahunan</span>
              </v-col>-->
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6">
                <span class="primary--text font-weight-bold">Wajib mengisi keterangan cuti</span>
                <v-radio-group
                  v-model="saldoCuti.is_keterangan"
                  row
                  data-vv-name="is_keterangan"
                  data-vv-as="Keterangan"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.is_keterangan')"
                >
                  <v-radio label="Ya" :value="true"></v-radio>
                  <v-radio label="Tidak" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      saldoCuti: {},
      defKategori: {
        nama: null,
        is_masa_kerja: false,
        masa_kerja: 0,
        is_approval: false,
        is_saldo: false,
        jumlah: 0,
        is_lampiran: false,
        is_akumulasi: false,
        sisa_cuti: 0,
        is_related: false,
        is_keterangan: false
      }
    };
  },
  mounted() {},
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.$validator.reset();
      this.saldoCuti = obj ? { ...obj } : { ...this.defKategori };
      return this.$refs.dlg.open();
    },
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("saldoCuti/form", this.saldoCuti);
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$info("Simpan Data Berhasil");
            this.$refs.dlg.resolve();
            return res;
          }
        })
        .catch(e => e);
    }
  }
};
</script>
